import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('schedule')

export default {
  namespaced: true,
  state: {
    schedules: [],
  },
  mutations: {
    setSchedule: (state, data) => { state.schedules = data }
  },
  actions: {
    getAllSchedules: async ({commit}, date ) => {
      try {
        let req_url = `schedule/timetable/${date}`;
        const response = await api.get(req_url)
        // console.log("schedules :", response.data)
        commit('setSchedule', response.data)
        return response.data
      } catch (e) {
        console.error('[axios] getSchedules :', e.message)
      }
    },
    getSchedules: async ({commit}, { date , ch }) => {
      try {
        let req_url = `schedule/date/${date}?ch=${ch}`;
        const response = await api.get(req_url)
        // console.log("schedules :", response.data)
        commit('setSchedule', response.data)
        return response.data
      } catch (e) {
        console.error('[axios] getSchedules :', e.message)
      }
    },
    getScheduleRange: async ({commit}, {start_date, end_date}) => {
      try {
        let req_url = `schedule/range?start_date=${date}&end_date='${end_date}`;
        const response = await api.get(req_url)
        // console.log("schedulesRange :", response.data)
        commit('setSchedules', response.data)
        return response.data
      } catch (e) {
        console.error('[axios] getSchedules :', e.message)
      }
    }
  }
}